import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { BaseListItem } from "../BaseListItem";
import { ReactComponent as NewTaskListIcon } from "../../assets/new-task-list.svg";

interface CreateTaskListItemProps {
  onClick: () => void;
}

export const CreateTaskListItem: FC<CreateTaskListItemProps> = ({
  onClick,
}) => {
  const { t } = useTranslations();

  return (
    <BaseListItem
      startSlot={<NewTaskListIcon />}
      title={t({
        id: "task-selection-popover.create-new-task",
        defaultMessage: "Create new task",
      })}
      subtitle={t({
        id: "tasks-page.tap-to-create",
        defaultMessage: "Tap to create",
      })}
      onClick={onClick}
    />
  );
};
